import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
`;

const NotFoundTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const NotFoundText = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
`;

const NotFoundLink = styled(Link)`
  color: var(--secondary-color);
  text-decoration: none;
  border: 2px solid var(--secondary-color);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--secondary-color);
    color: var(--primary-color);
  }
`;

function NotFound() {
  return (
    <NotFoundWrapper>
      <NotFoundTitle>404 - 페이지를 찾을 수 없습니다</NotFoundTitle>
      <NotFoundText>요청하신 페이지를 찾을 수 없습니다.</NotFoundText>
      <NotFoundLink to="/">홈으로 돌아가기</NotFoundLink>
    </NotFoundWrapper>
  );
}

export default NotFound;